export default __webpack_public_path__ + "static/media/chabot.4d20a261.png";